import { green, red } from '@mui/material/colors';
import { Divider, styled } from '@/theme/index';

export const StyledDivider = styled(Divider)(({ theme }) => ({
  border: '2px solid #FFFFFF00',

  '&.Mui-selected': {
    '&.red': {
      color: red[400],
    },

    '&.yellow': {
      color: theme.palette.warning.light,
    },

    '&.green': {
      color: green[500],
    },
  },
}));
